export default __webpack_public_path__ + "static/media/mail-dark.6c3290cf.svg";